// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-step-editor-header-button{background:#b5e6e5;color:#399999;display:flex;align-items:center}.shared-step-editor-header-button:hover{background:#399999;color:#b5e6e5}", ""]);
// Exports
module.exports = exports;
